import { useQuery } from '@tanstack/react-query'
import { shipmentsApi } from '@/lib/api'
import type { Shipment, ShipmentSummary } from '@/types'

function normalizeShipment(raw: Shipment & { pallets?: unknown }): Shipment {
  return {
    ...raw,
    additions: raw.additions ?? [],
    items_count: raw.items_count ?? 0,
    exported_at: raw.exported_at ?? null,
  }
}

function normalizeSummary(raw: ShipmentSummary & { pallets_count?: number }): ShipmentSummary {
  return {
    ...raw,
    additions_count: raw.additions_count ?? raw.pallets_count ?? 0,
    items_count: raw.items_count ?? 0,
  }
}

export function useShipments() {
  return useQuery({
    queryKey: ['shipments'],
    queryFn: async () => {
      const { data } = await shipmentsApi.getAll()
      const list = Array.isArray(data) ? data : []
      return list.map((row) => normalizeSummary(row as ShipmentSummary & { pallets_count?: number }))
    },
    refetchOnMount: 'always',
    staleTime: 0,
  })
}

export function useShipment(id: string) {
  return useQuery({
    queryKey: ['shipment', id],
    queryFn: async () => {
      const { data } = await shipmentsApi.getById(id)
      return normalizeShipment(data as Shipment & { pallets?: unknown })
    },
    enabled: !!id,
    refetchOnMount: 'always',
    staleTime: 0,
  })
}
